export type StepDotsProps = {
  total: number
  current: number
}

export const StepDots = ({ total, current }: StepDotsProps) => (
  <div
    style={{
      display: 'flex',
      gap: 4,
      alignItems: 'center',
      justifyContent: 'center',
      padding: '6px 0 8px',
    }}
  >
    {Array.from({ length: total }).map((_, i) => {
      const done = i + 1 < current
      const active = i + 1 === current
      return (
        <span
          key={i}
          style={{
            width: active ? 22 : 6,
            height: 6,
            borderRadius: 3,
            background: active ? 'var(--terra)' : done ? 'var(--ink-2)' : 'var(--paper-3)',
            transition: 'all 0.2s',
          }}
        />
      )
    })}
  </div>
)
